import React from "react";
import { Calendar } from "lucide-react";

/**
 * EventSelector - GCHL Brand styled event dropdown
 *
 * Uses forest green accent on focus, proper dark mode support,
 * and matches the overall admin dashboard styling.
 */
const EventSelector = ({ events = [], selectedEvent, handleEventChange }) => {
  return (
    <div className="mb-6">
      <label
        htmlFor="event"
        className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
      >
        Select Event
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Calendar className="w-5 h-5 text-gray-400 dark:text-navy-500" />
        </div>
        <select
          id="event"
          className="
            w-full pl-10 pr-4 py-3
            bg-white dark:bg-navy-800
            border border-gray-300 dark:border-navy-600
            rounded-xl
            text-gray-900 dark:text-gray-100
            font-medium
            focus:ring-2 focus:ring-forest-500 dark:focus:ring-gold-400
            focus:border-forest-500 dark:focus:border-gold-400
            transition-colors duration-200
            appearance-none
            cursor-pointer
          "
          value={selectedEvent?.id || ""}
          onChange={(e) => {
            const eventId = Number(e.target.value);
            handleEventChange(eventId);
          }}
        >
          <option value="" className="text-gray-500">-- Select Event --</option>
          {events.map((event) => (
            <option key={event.id} value={event.id}>
              {new Date(event.date).toLocaleDateString()} - {event.course_name}
            </option>
          ))}
        </select>
        {/* Custom dropdown arrow */}
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          <svg className="w-5 h-5 text-gray-400 dark:text-navy-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default React.memo(EventSelector);